/* eslint-disable no-console */
import { Component } from "@angular/core";
@Component({
  selector: "gh-example-mentions-component",
  templateUrl: "./example-mentions.component.html",
  styleUrls: ["./example-mentions.component.less"],
})
export class ExampleMentionsComponent {
  public inputValue = "@omg";
  public suggestions = ["suggestion", "Pencho", "omg", "djidji", "hmmmm", "this is tha last suggestion!"];

  public inputFramework = "";
  public webFrameworks = [
    { name: "React", type: "JavaScript", icon: "https://zos.alipayobjects.com/rmsportal/LFIeMPzdLcLnEUe.svg" },
    { name: "Angular", type: "JavaScript", icon: "https://zos.alipayobjects.com/rmsportal/PJTbxSvzYWjDZnJ.png" },
    { name: "Dva", type: "Javascript", icon: "https://zos.alipayobjects.com/rmsportal/EYPwSeEJKxDtVxI.png" },
    { name: "Flask", type: "Python", icon: "https://zos.alipayobjects.com/rmsportal/xaypBUijfnpAlXE.png" },
  ];

  public valueWith(data: { name: string; type: string; icon: string }): string {
    return data.name;
  }

  public onChange(value: string): void {
    console.log(value);
  }

  public onSelect(suggestion: string): void {
    console.log(`onSelect ${suggestion}`);
  }
}
